unit UHolidayForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UStampModel,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, UMainConfig, WEBLib.Buttons, UHolidayList;

type
  THolidayForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlButton: TPanel;
    btnInsert: TBitBtn;
    pnlData: TPanel;
    sgAbw: TStringGrid;
    procedure btnBackClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure sgAbwCheckClick(Sender: TObject; ACol, ARow: Integer;
      Checked: Boolean);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    [Async]
    procedure sgAbwClickCell(Sender: TObject; ACol, ARow: Integer); async;
    [Async]
    procedure btnInsertClick(Sender: TObject); async;
    procedure WebFormCreate(Sender: TObject);
  private
    FMainConfig: TMainConfig;
    FHolidayList: THolidayList;
    FFakStamp: TStampModel;
    FStamp: TStampModel;
    procedure GetHolidayList;
    procedure GetLastFakStamp;
    procedure GetStatus;
    procedure sgAbwInit;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetHolidayList(const Value: THolidayList);
    procedure SetFakStamp(const Value: TStampModel);
    procedure SetStamp(const Value: TStampModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property HolidayList: THolidayList read FHolidayList write SetHolidayList;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;
  protected procedure LoadDFMValues; override; end;

var
  HolidayForm: THolidayForm;

implementation

uses
  UEssentialHelper, UGridHelper, UHolidayModel, UHolidayDetailForm,
  UHolidayNewForm;

{$R *.dfm}

procedure THolidayForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure THolidayForm.btnInsertClick(Sender: TObject);
var
  frm: THolidayNewForm;
begin
  Self.MainConfig.TimerReset;
  frm := THolidayNewForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(THolidayNewForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
    Self.WebFormResize(Sender);
    Self.GetHolidayList;
  end;
end;

procedure THolidayForm.GetHolidayList;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayList then
      Self.HolidayList := Sender as THolidayList;
    Self.sgAbwInit;
  end;

begin
  if Self.HolidayList = nil then
    Self.HolidayList := THolidayList.Create
  else
    Self.HolidayList.Clear;
  Self.HolidayList.OnPropertyChanged := Callback;
  Self.HolidayList.GetAll(Self.MainConfig.Uri,
    Self.MainConfig.AppForLeaveConfig.ApplicationCount,
    Self.MainConfig.User.PersonalNr);
end;

procedure THolidayForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure THolidayForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.Uri);
end;

procedure THolidayForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure THolidayForm.SetHolidayList(const Value: THolidayList);
begin
  FHolidayList := Value;
end;

procedure THolidayForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.WebFormResize(Self);
  Self.GetStatus;
  Self.GetHolidayList;
end;

procedure THolidayForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure THolidayForm.sgAbwCheckClick(Sender: TObject; ACol, ARow: Integer;
  Checked: Boolean);
begin
  Self.MainConfig.TimerReset;
  if ACol = 11 then
    sgAbw.CheckState[ACol, ARow] := not Checked;
end;

procedure THolidayForm.sgAbwClickCell(Sender: TObject; ACol, ARow: Integer);
var
  frm: THolidayDetailForm;
  item: THolidayModel;
begin
  Self.MainConfig.TimerReset;
  if (ARow > 0) and (sgAbw.Cells[1, ARow] <> '') then
  begin
    item := Self.HolidayList.GetByItd(StrToInt(sgAbw.Cells[1, ARow]));
    if item <> nil then
    begin
      frm := THolidayDetailForm.Create(Self);
      frm.Caption := Self.Caption;
      frm.Popup := false;
      await(THolidayDetailForm, frm.Load);
      frm.MainConfig := Self.MainConfig;
      frm.Holiday := item;
      try
        Self.Hide;
        await(TModalResult, frm.Execute);
      finally
        frm.Free;
        Self.Show;
        Self.WebFormResize(Sender);
        Self.GetHolidayList;
      end;
    end;
  end;
end;

procedure THolidayForm.sgAbwInit;
var
  i: Integer;
  item: THolidayModel;
  farbe: string;
begin
  sgAbw.ColCount := 14;
  sgAbw.RowCount := Self.HolidayList.Count + 1;
  sgAbw.FixedCols := 0;
  sgAbw.FixedRows := 1;
  sgAbw.Cells[0, 0] := '';
  sgAbw.Cells[1, 0] := 'Id';
  sgAbw.Cells[2, 0] := '';
  sgAbw.Cells[3, 0] := '';
  sgAbw.Cells[4, 0] := Bold('Status');
  sgAbw.Cells[5, 0] := '';
  sgAbw.Cells[6, 0] := Bold('Abwesenheit');
  sgAbw.Cells[7, 0] := Bold('von');
  sgAbw.Cells[8, 0] := Bold('bis');
  sgAbw.Cells[9, 0] := Bold('Grund');
  sgAbw.Cells[10, 0] := Bold('erstellt am');
  sgAbw.Cells[11, 0] := Bold('genehmigt');
  sgAbw.Cells[12, 0] := Bold('von');
  sgAbw.Cells[13, 0] := Bold('Begründung');
  sgAbw.ColWidths[0] := 5;
  sgAbw.ColWidths[1] := 0;
  sgAbw.ColWidths[2] := 20;
  sgAbw.ColWidths[3] := 5;
  sgAbw.ColWidths[4] := 100;
  sgAbw.ColWidths[5] := 5;
  sgAbw.ColWidths[6] := 150;
  sgAbw.ColWidths[7] := 85;
  sgAbw.ColWidths[8] := 85;
  sgAbw.ColWidths[9] := 150;
  sgAbw.ColWidths[10] := 180;
  sgAbw.ColWidths[11] := 60;
  sgAbw.ColWidths[12] := 50;
  sgAbw.ColWidths[13] := 250;
  sgAbw.ColAlignments[11] := taCenter;
  for i := 0 to Self.HolidayList.Count - 1 do
  begin
    item := Self.HolidayList.Items[i];
    sgAbw.Cells[0, i + 1] := '';
    sgAbw.Cells[1, i + 1] := IntToStr(item.Id);
    farbe := 'white';
    case item.Status of
      0:
        farbe := RgbColorToHtmlColor
          (Self.MainConfig.AppForLeaveConfig.ApplicationNew);
      1:
        farbe := RgbColorToHtmlColor
          (Self.MainConfig.AppForLeaveConfig.ApplicationInProcess);
      2:
        farbe := RgbColorToHtmlColor
          (Self.MainConfig.AppForLeaveConfig.ApplicationApproved);
      3:
        farbe := RgbColorToHtmlColor
          (Self.MainConfig.AppForLeaveConfig.ApplicationRejected);
      4:
        farbe := RgbColorToHtmlColor
          (Self.MainConfig.AppForLeaveConfig.ApplicationCanceled);
    end;
    sgAbw.Cells[2, i + 1] := AlignCenter('*', farbe, farbe);
    sgAbw.Cells[4, i + 1] := item.StatusText;
    sgAbw.Cells[6, i + 1] := item.Abw.Bezeichnung;
    sgAbw.Cells[7, i + 1] := FormatDateTime('ddd. dd.mm.yyyy', item.Von);
    sgAbw.Cells[8, i + 1] := FormatDateTime('ddd. dd.mm.yyyy', item.Bis);
    sgAbw.Cells[9, i + 1] := item.Grund;
    sgAbw.Cells[10, i + 1] := FormatDateTime('ddd. dd.mm.yyyy hh:nn',
      item.Angelegt);
    if not sgAbw.HasCheckBox(11, i + 1) then
      sgAbw.AddCheckBox(11, i + 1, item.Genehmigt)
    else
      sgAbw.CheckState[11, i + 1] := item.Genehmigt;
    sgAbw.Cells[12, i + 1] := item.GenehmigtVon;
    sgAbw.Cells[13, i + 1] := item.Begruendung;
  end;
end;

procedure THolidayForm.WebFormCreate(Sender: TObject);
begin
  Self.Stamp := nil;
  Self.FakStamp := nil;
end;

procedure THolidayForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure THolidayForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Urlaubsanträge';
    btnInsert.Top := 4;
    btnInsert.Left := 4;
    btnInsert.Width := 120;
    btnInsert.Height := 32;
    btnInsert.GlyphSize := 24;
    pnlButton.Height := 40;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Urlaubsanträge';
    btnInsert.Top := 8;
    btnInsert.Left := 8;
    btnInsert.Width := 160;
    btnInsert.Height := 48;
    btnInsert.GlyphSize := 32;
    pnlButton.Height := 64;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
end;

procedure THolidayForm.WebFormShow(Sender: TObject);
begin
  Self.WebFormResize(Sender);
end;

procedure THolidayForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlButton := TPanel.Create(Self);
  btnInsert := TBitBtn.Create(Self);
  pnlData := TPanel.Create(Self);
  sgAbw := TStringGrid.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlButton.BeforeLoadDFMValues;
  btnInsert.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  sgAbw.BeforeLoadDFMValues;
  try
    Name := 'HolidayForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UHolidayForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Urlaubsantr'#228'ge';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UHolidayForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlButton.SetParentComponent(Self);
    pnlButton.Name := 'pnlButton';
    pnlButton.Left := 0;
    pnlButton.Top := 92;
    pnlButton.Width := 640;
    pnlButton.Height := 64;
    pnlButton.Align := alTop;
    pnlButton.Caption := 'pnlButton';
    pnlButton.ChildOrder := 3;
    pnlButton.ShowCaption := False;
    btnInsert.SetParentComponent(pnlButton);
    btnInsert.Name := 'btnInsert';
    btnInsert.Tag := 1;
    btnInsert.Left := 8;
    btnInsert.Top := 8;
    btnInsert.Width := 160;
    btnInsert.Height := 48;
    btnInsert.Caption := 'Antrag stellen';
    btnInsert.Color := clNone;
    btnInsert.Glyph.LoadFromFile('UHolidayForm.pnlButton.btnInsert.Glyph.png');
    btnInsert.GlyphSize := 32;
    btnInsert.HeightPercent := 100.000000000000000000;
    btnInsert.WidthPercent := 100.000000000000000000;
    SetEvent(btnInsert, Self, 'OnClick', 'btnInsertClick');
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 0;
    pnlData.Top := 156;
    pnlData.Width := 640;
    pnlData.Height := 300;
    pnlData.Align := alClient;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 4;
    pnlData.ShowCaption := False;
    sgAbw.SetParentComponent(pnlData);
    sgAbw.Name := 'sgAbw';
    sgAbw.Left := 0;
    sgAbw.Top := 0;
    sgAbw.Width := 640;
    sgAbw.Height := 300;
    sgAbw.Align := alClient;
    sgAbw.ColCount := 1;
    sgAbw.FixedCols := 0;
    sgAbw.RowCount := 1;
    sgAbw.FixedRows := 0;
    sgAbw.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    sgAbw.TabOrder := 0;
    sgAbw.RangeEdit.Max := 100.000000000000000000;
    sgAbw.RangeEdit.Step := 1.000000000000000000;
    sgAbw.SelectionTextColor := clBlack;
    sgAbw.HeightPercent := 100.000000000000000000;
    sgAbw.WidthPercent := 100.000000000000000000;
    SetEvent(sgAbw, Self, 'OnClickCell', 'sgAbwClickCell');
    SetEvent(sgAbw, Self, 'OnCheckClick', 'sgAbwCheckClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlButton.AfterLoadDFMValues;
    btnInsert.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    sgAbw.AfterLoadDFMValues;
  end;
end;

end.
